import { createStyles } from '@material-ui/core/styles';

export default createStyles({
  mainCnt: {
    backgroundColor: '#DDDDDD',
    paddingTop: 20,
    padding: '10px',
    margin: '14px 330px -5px 10px',
    boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 3px 1px -2px rgba(0,0,0,0.12)',
  },
  rowContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  firstRow: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  secondRow: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  firstSelection: {
    'display': 'flex',
    'alignItems': 'center',
    'flexWrap': 'wrap',
    '& > *:not(:last-child)': {
      marginRight: 10,
    },
  },
  manualContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    marginRight: 10,
  },
  clearBtn: {
    'marginLeft': 0,
    'height': 40,
    'marginRight': 5,
    'cursor': 'pointer',
    'textDecoration': 'underline',
    '& svg': {
      height: '18px',
      marginLeft: '-5px',
      marginRight: '5px',
    },
    '&:hover': {
      color: 'black',
      textDecoration: 'underline',
    },

  },
  backBtn: {
    'fontSize': '13px',
    'height': 32,
    'padding': '7px',
    'marginLeft': 8,
    'marginTop': -12,
    'cursor': 'pointer',
    'color': 'black',
    'background': 'white',
    'border': '1px solid gray',
    'boxShadow': 'none',
    'borderRadius': 6,
    '&:hover': {
      background: 'white',
      border: '1px solid gray',
      color: 'black',
      boxShadow: 'none',
    },
  },
  search: {
    'color': 'white',
    'minWidth': 105,
    'height': 30,
    'marginTop': -16,
    'padding': '8px',
    '& svg': {
      height: '20px',
      marginleft: '-14px',
    },
  },
  selectedVehicle: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 20,
    marginTop: -12,
  },
  selectedVehicleLabel: {
    fontSize: 14,
    fontWeight: 600,
    marginRight: 10,
  },
  selectedVehicleValue: {
    marginTop: '-3px',
  },
});
